import { getFiles } from '@/API/repositories/file';
import { getLanguages } from '@/API/repositories/language';
import { FILE_TYPES } from '@/common/constants/fileTypes';
import { downloadFile } from '@/common/functions/downloadFile';
import { handleMapToOptions } from '@/common/functions/handleMapToOptions';
import { useRequestsContext } from '@/common/hooks/requestHook';
import { useMessageQueueContext } from '@/common/hooks/useMessageQueue';
import { useEffect, useState } from 'react';
import { WORKFLOWS_OPTIONS } from './constants/workflows';

const useAttachments = () => {
	const { makeRequest, hasUnfilledRequest } = useRequestsContext();
	const { addMessage } = useMessageQueueContext();

	const [languageOptions, setLanguageOptions] = useState([]);
	const [show, setShow] = useState(false);
	const [selectedFile, setSelectedFile] = useState();
	const [files, setFiles] = useState([]);
	const [loadingFiles, setLoadingFiles] = useState([]);

	const loadPages = async () => {
		setFiles([]);
		const attachmentsResponse = await makeRequest(() =>
			getFiles(FILE_TYPES.ATTACHMENT),
		);
		const languagesResponse = await makeRequest(getLanguages);

		if (!attachmentsResponse?.data || !languagesResponse?.data) {
			return addMessage('Something went wrong', 'error');
		}

		const languages = handleMapToOptions(
			languagesResponse.data,
			'short',
			'_id',
		);

		attachmentsResponse.data.forEach((att) => {
			const language = languages.find((lang) => lang.value === att.language);
			const workflow = WORKFLOWS_OPTIONS.find(
				(wk) => wk.value === att.workflow,
			);
			att.language = language;
			att.workflow = workflow;
		});

		setFiles(attachmentsResponse.data);
		setLanguageOptions(languages);
	};

	const handleDownloadFile = (file) =>
		downloadFile(file, makeRequest, setLoadingFiles);

	useEffect(() => {
		loadPages();
	}, []);

	const isLoading = hasUnfilledRequest(getFiles, getLanguages);

	return {
		isLoading,
		setSelectedFile,
		setShow,
		show,
		selectedFile,
		loadPages,
		files,
		loadingFiles,
		handleDownloadFile,
		languageOptions,
	};
};

export default useAttachments;
